export function formatPercent(percent?: number): string {
  if (!percent) {
    return 'N/A';
  }

  return `${Math.floor(percent).toFixed(1)}% \n TKL`;
}
